import {ChangeDetectorRef, Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {Tooltip} from '../../domain/tooltip';
import {LookupService} from '../../services/lookup.service';
import {UtilService} from '../../services/util.service';
import * as _ from 'lodash';

@Component({
    selector: 'app-search-tree-lite',
    templateUrl: './search-tree-lite.component.html',
    styleUrls: ['./search-tree-lite.component.scss']
})
export class SearchTreeLiteComponent implements OnInit, OnChanges {

    @Input() vehicleIdentification;
    @Input() tooltips: Tooltip[];
    public notFoundText = 'Keine Ergebnisse';
    public makes = [];
    public mainTypes = [];
    private mainType: any;

    constructor(private lookupService: LookupService,
                private cd: ChangeDetectorRef) {
    }

    ngOnInit() {
        this.updateMakes();
    }

    updateMakes() {
        setTimeout(() => {
        this.lookupService.getMakes().then((data) => {
            this.makes = [];
            for (const make of data) {
                const obj = {value: make, display: make.makeName};
                this.makes.push(obj);

            }
            if (this.vehicleIdentification && this.vehicleIdentification.manufacturer) {
                UtilService.resolveObject('makeCode', this.makes, this.vehicleIdentification, 'manufacturer');
                this.updateMainTypes();
                this.cd.markForCheck();
            }
        });
        });
    }

    updateMainTypes() {
        setTimeout(() => {
            this.mainTypes = [];
            if (!this.vehicleIdentification.manufacturer) {
                return;
            }
            if (this.vehicleIdentification.mainType) {
                this.mainType = _.cloneDeep(this.vehicleIdentification.mainType);
            } else {
                this.mainType = null;
            }
            this.vehicleIdentification.mainType = null;
            this.lookupService.getMainTypes(this.vehicleIdentification.manufacturer.makeCode)
                .then((data) => {
                    for (const mainType of data) {
                        const obj = {value: mainType, display: mainType.searchSeries};
                        this.mainTypes.push(obj);
                    }
                    this.mainTypes = [...this.mainTypes];
                    if (this.vehicleIdentification && this.mainType) {
                        const obj = _.find(this.mainTypes,
                            ['value.searchSeriesCode', this.mainType.searchSeriesCode]);
                        if (obj) {
                            this.vehicleIdentification.mainType = obj.value;
                        } else {
                            this.vehicleIdentification.mainType = null;
                        }
                    }

                    this.cd.markForCheck();
                });
        });
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.vehicleIdentification !== undefined) {
            this.updateMakes();
        }
    }

    onMainTypeChange() {
        setTimeout(() => {
            this.vehicleIdentification.searchSeriesCode = this.vehicleIdentification.mainType.searchSeriesCode;
        });
    }

    compareManufacturer(a: any, b: any) {
        return a.value.makeCode === b.makeCode;
    }

    compareMainType(a: any, b: any) {
        return a.value.searchSeriesCode === b.searchSeriesCode;
    }

}
